import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Add, Block, Delete } from "@material-ui/icons";
import SendIcon from "@material-ui/icons/Send";
import { CHECK_LENGTH_PHONE_SEARCH } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import IconSearch from "app/common/Icon/IconSearch";
import {
  GENDER_FEMALE_VALUE,
  LIST_GENDER,
  MARKETING_TYPE,
  RELATIONSHIP_TYPES,
} from "app/common/LocalConst";
import {
  convertDataLead,
  getDateTime,
  getSourceCustomerCompanionCode,
  hideMiddleDigits,
  isAdmin,
} from "app/common/LocalFunction";
import { renderOptionsCheckInCustomer } from "app/EgretLayout/SharedCompoents/SelectCustomer";
import SearchPhoneAndSelectInput from "app/PatientManagement/CheckInList/Component/SearchPhoneAndSelectInput";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { useStore } from "app/stores";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { filterCustomerOptions } from "utils";
import * as Yup from "yup";
import { toast } from "react-toastify";

const ListCheckInDependentPerson = ({
  open,
  onClose,
  initCheckInDependentPerson,
  saveCheckCompanions,
  handleChangeFormSearchDependentPerson,
  customerSourceForCompanionDefault,
  handleChangeFormSearchDuplicateOnlyLead,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const validationSchema = Yup.object().shape({
    companions: Yup.array().of(
      Yup.object().shape({
        patient: Yup.object()
          .shape({
            displayName: Yup.string().required(
              "Vui lòng nhập họ tên người đi kèm"
            ),
          })
          .nullable()
          .required("Thông tin người đi kèm là bắt buộc"),

        relationship: Yup.mixed().required("Vui lòng chọn mối quan hệ"),
        currentPatientSource: Yup.mixed().required("Vui lòng chọn nguồn"),
        // currentPatientSourceDetail: Yup.mixed().required("Vui lòng chọn nguồn (Chi tiết)"),
      })
    ),
  });

  return (
    <>
      <PopupForm
        open={open}
        size="sm"
        handleClose={onClose}
        title={"Check in người đi kèm"}
        formik={{
          initialValues: {
            ...initCheckInDependentPerson,
          },
          enableReinitialize: true,
          validationSchema: validationSchema,

          onSubmit: async (values, { setSubmitting }) => { },
        }}
        action={({ submitForm, setFieldValue, isSubmitting }) => {
          return (
            <div className="flex-center gap-1">
              {/* <CommonButton
                className="btn-add"
                type="submit"
                disabled={isSubmitting}
              >
                {!isMobile && <IconUserEdit className="mr-2 " />}
                Check In
              </CommonButton> */}

              <CommonButton className="btn-gray" onClick={onClose}>
                {!isMobile && <Block className="mr-2" />}
                Đóng
              </CommonButton>
            </div>
          );
        }}
      >
        {({ setFieldValue, values, setSubmitting, submitForm }) => {
          return (
            <>
              <ValuesForm
                isMobile={isMobile}
                saveCheckCompanions={saveCheckCompanions}
                handleChangeFormSearchDependentPerson={
                  handleChangeFormSearchDependentPerson
                }
                customerSourceForCompanionDefault={
                  customerSourceForCompanionDefault
                }
                handleChangeFormSearchDuplicateOnlyLead={
                  handleChangeFormSearchDuplicateOnlyLead
                }
              />
            </>
          );
        }}
      </PopupForm>
    </>
  );
};

const ValuesForm = observer(
  ({
    saveCheckCompanions,
    isMobile,
    handleChangeFormSearchDependentPerson,
    customerSourceForCompanionDefault,
    handleChangeFormSearchDuplicateOnlyLead
  }) => {
    const { values, setFieldValue, validateForm, setTouched } =
      useFormikContext();
    const isAdminRole = isAdmin();
    const { t } = useTranslation();

    const getNameSpace = (nameSpace, index) => {
      return `companions.[${index}].${nameSpace}`;
    };

    const handleChangePhoneNumberChange = async (phoneNumber, index) => {
      if (phoneNumber && phoneNumber?.length >= 10) {
        const data = await handleChangeFormSearchDependentPerson({
          phoneNumber,
          oldData: values, // luu tạm dữ liệu hiện tại,lưu vào biến search duplicate để có thể set lại sau khi chọn
          currentIndex: index,
        });
        // if (data?.length === 0) {
        //   setFieldValue(getNameSpace("isMainPhoneNumber", index), true);
        // }
      }
    };
    const [disabledCheckInIndexes, setDisabledCheckInIndexes] = useState([]);
    let companyCode = getSourceCustomerCompanionCode();

    return (
      <>
        <CompanionSharedSourceEffect />
        <Grid container spacing={1} className="w-100 m-0">
        <Grid item xs={12}>
          <ul className="patient-info-checkin">
            <li>
              🕒 <span className="label">Thời gian check in:</span>{" "}
              {getDateTime(values?.issueDate)}
            </li>
            <li>
              🏢 <span className="label">Cơ sở:</span>{" "}
              {values?.department?.name}
            </li>
            <li>
              🙋‍♀️ <span className="label">Người check in:</span>{" "}
              {values?.receptionist?.staffName}
            </li>
            <li>
              🧍‍♀️<span className="label">Khách hàng:</span>{" "}
              {values?.patient?.displayName}
              {/* {getDateTime(values?.patient?.orderDate)} */}
            </li>
            <li className="flex gap-3 align-center">
              <div className="flex gap-1">
                📞 <span className="label">SĐT:</span>{" "}
                {hideMiddleDigits(values?.patient?.phoneNumber)}
              </div>
              <GlobitsCheckBox
                name="isMainPhoneNumber"
                label="Là số điện thoại chính"
                disabled
              />
            </li>
          </ul>
        </Grid>
        <FieldArray name="companions">
          {({ remove, push }) => (
            <>
              <Grid item xs={12} lg={6}>
                <GlobitsDateTimePicker
                  name="issueDate"
                  label="Thời gian check in"
                  isDateTimePicker
                />
              </Grid>

              <Grid item xs={12} lg={6} className="flex justify-end">
                <CommonButton
                  onClick={() => {
                    const patient = {
                      phoneNumber: values?.patient?.phoneNumber,
                      displayName: "",
                      gender: LIST_GENDER[1].value,
                    };
                    const companionSource = values?.currentPatientSource?.sharedSource || customerSourceForCompanionDefault;
                    push({
                      patient,
                      issueDate: values?.issueDate,
                      currentPatientSource: companionSource,
                    });
                  }}
                >
                  <Add /> Thêm người đi kèm
                </CommonButton>
              </Grid>

              {values?.companions?.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <div
                    className={`companion-card ${item?.receptionEncId ? "alice-blue" : ""
                      }`}
                  >
                    <div className="companion-header flex justify-between">
                      Khách hàng {index + 1}
                      {item?.receptionEncId && <span>✔️ Đã check in</span>}
                    </div>

                    <Grid container spacing={1}>
                      <Grid item xs={12} md={6}>
                        <GlobitsPagingAutocomplete
                          label="Nguồn"
                          name={getNameSpace("currentPatientSource", index)}
                          api={pagingCustomerSource}
                          searchObject={{
                            listCustomerSourceCode: companyCode,
                            level: 2,
                          }}
                          required
                          disabled={Boolean(values?.currentPatientSource?.sharedSource)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <GlobitsPagingAutocomplete
                          label="Nguồn chi tiết"
                          name={getNameSpace(
                            "currentPatientSourceDetail",
                            index
                          )}
                          api={pagingCustomerSource}
                          searchObject={{
                            parentId:
                              getIn(
                                values,
                                getNameSpace("currentPatientSource", index)
                              )?.id || "",
                          }}
                          //disabled={Boolean(values?.currentPatientSource?.sharedSource)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} className="flex gap-1">
                        <SearchPhoneAndSelectInput
                          name={getNameSpace("patient.phoneNumber", index)}
                          label="Số điện thoại"
                          autoUpercase
                          required
                          checkLength={CHECK_LENGTH_PHONE_SEARCH}
                          isSearchFreeSolo
                          // className="select-customer"
                          onChange={(_, patient) => {
                            // check là lead hay patient
                            if (patient?.saleType) {
                              let convertPatient = convertDataLead(patient);
                              setFieldValue(getNameSpace("patient", index), {
                                ...convertPatient,
                                phoneNumber: patient?.phoneNumber,
                              });
                              setFieldValue(
                                getNameSpace("leadId", index),
                                patient?.id
                              );
                              setFieldValue(
                                getNameSpace("marketingType", index),
                                patient?.marketingType
                              );
                              setFieldValue(
                                getNameSpace("lead", index),
                                patient
                              );
                            } else {
                              setFieldValue(getNameSpace("patient", index), {
                                ...patient,
                                phoneNumber: patient?.phoneNumber,
                                displayName:
                                  patient?.fullName ||
                                  patient?.displayName ||
                                  "",
                                gender: patient?.gender
                                  ? patient?.gender
                                  : GENDER_FEMALE_VALUE,
                              });
                            }
                            setFieldValue(
                              getNameSpace("marketingType", index),
                              null
                            );
                          }}
                          disableClearable
                          ListboxComponent={forwardRef((props, ref) => {
                            const { children, ...other } = props;
                            return (
                              <ul {...other} ref={ref}>
                                <ol
                                  className={
                                    "custom-listbox-customer box-checkin dependent-person"
                                  }
                                >
                                  <li>{children}</li>
                                </ol>
                              </ul>
                            );
                          })}
                          renderOption={(option) =>
                            renderOptionsCheckInCustomer(option)
                          }
                          filterOptions={filterCustomerOptions}
                          handleOnInput={(text) => {
                            console.log("text", text);
                            if (item?.leadId) {
                              setFieldValue(
                                getNameSpace("leadId", index),
                                null
                              );
                              setFieldValue(getNameSpace("lead", index), null);
                              setFieldValue(
                                getNameSpace("patient.id", index),
                                null
                              );
                              setFieldValue(
                                getNameSpace("patient.code", index),
                                null
                              );
                              setFieldValue(
                                getNameSpace("patient.leadCode", index),
                                null
                              );
                            } else if (item?.patient?.id) {
                              setFieldValue(
                                getNameSpace("patient.id", index),
                                null
                              );
                              setFieldValue(
                                getNameSpace("patient.code", index),
                                null
                              );
                            }
                          }}
                        />
                        {/* <GlobitsTextField
                          label="Số điện thoại"
                          name={getNameSpace("patient.phoneNumber", index)}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFieldValue(
                              getNameSpace("patient.phoneNumber", index),
                              value
                            );
                            if (
                              value &&
                              value.length >= CHECK_LENGTH_PHONE_SEARCH
                            ) {
                              handleChangePhoneNumberChange(value, index);
                            }
                          }}
                        /> */}
                        <CheckDuplicatePhoneButton
                          handleCheckDuplicatePhone={() => {
                            const value = getIn(values, getNameSpace("patient.phoneNumber", index));
                            if (
                              value &&
                              value.length >= CHECK_LENGTH_PHONE_SEARCH
                            ) {
                              handleChangePhoneNumberChange(value, index);
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <GlobitsTextField
                          name={getNameSpace("patient.displayName", index)}
                          label={`Họ tên ${item?.leadId ? "lead" : "khách hàng"
                            }`}
                          autoUpercase
                          required
                        />
                      </Grid>
                      {!item?.receptionEncId &&
                        (item?.leadId || item?.patient?.id) && (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            className="flex gap-2 align-end"
                          >
                            {CustomerInfoSelectPhone(item)}
                          </Grid>
                        )}

                      <Grid item xs={12} md={6}>
                        <GlobitsSelectInput
                          name={getNameSpace("patient.gender", index)}
                          label={t("gender")}
                          options={LIST_GENDER}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <GlobitsSelectInput
                          name={getNameSpace("relationship", index)}
                          label={t("Mối quan hệ")}
                          options={RELATIONSHIP_TYPES}
                          required
                        />
                      </Grid>
                      {item?.leadId && (
                        <Grid item xs={12} sm={6}>
                          <GlobitsSelectInput
                            label={t("Loại khách")}
                            name={getNameSpace("marketingType", index)}
                            options={MARKETING_TYPE}
                            disabled={!isAdminRole}
                          />
                        </Grid>
                      )}

                      {!item?.receptionEncId && (
                        <Grid
                          item
                          xs={12}
                          md={12}
                          className="flex flex-end gap-1"
                        >
                          <CommonButton
                            className="btn"
                            onClick={() => remove(index)}
                          >
                            <Delete />
                            {!isMobile && "Xóa"}
                          </CommonButton>
                          <CommonButton
                            className="btn-primary"
                            disabled={disabledCheckInIndexes?.includes(index)}
                            onClick={async () => {
                              // Check trường displayName k cho khoảng cách .trim
                              if (
                                values?.companions?.[index]?.patient
                                  ?.displayName
                              ) {
                                values.companions[index].patient.displayName =
                                  values.companions[
                                    index
                                  ].patient.displayName.trim();
                              }

                              if (
                                values?.patient?.phoneNumber ===
                                item?.patient?.phoneNumber
                              ) {
                                toast.warning(
                                  "SĐT của người đi kèm không được trùng với SĐT của người đến chính."
                                );
                                return;
                              }

                              //  ko cho người dùng spam nút check in, disable lại
                              if (disabledCheckInIndexes.includes(index))
                                return; // tránh double click
                              setDisabledCheckInIndexes((prev) => [
                                ...prev,
                                index,
                              ]);
                              try {
                                const fieldTouched = {
                                  companions: values.companions.map(() => ({
                                    patient: {
                                      displayName: true,
                                      phoneNumber: true,
                                    },
                                    relationship: true,
                                    currentPatientSource: true,
                                    // currentPatientSourceDetail: true,
                                  })),
                                };
                                setTouched(fieldTouched);

                                const errors = await validateForm();
                                if (
                                  !getIn(
                                    errors,
                                    `companions[${index}].patient.displayName`
                                  ) &&
                                  !getIn(
                                    errors,
                                    `companions[${index}].relationship`
                                  ) &&
                                  !getIn(
                                    errors,
                                    `companions[${index}].currentPatientSource`
                                  )
                                ) {
                                  const phoneNumber = getIn(
                                    values,
                                    `companions[${index}].patient.phoneNumber`
                                  );

                                  if (!item?.leadId && !item?.patient?.id) {
                                    const data =
                                      await handleChangeFormSearchDependentPerson({
                                        phoneNumber,
                                        oldData: values, // luu tạm dữ liệu hiện tại,lưu vào biến search duplicate để có thể set lại sau khi chọn
                                        currentIndex: index,
                                      });
                                    //console.log("data", data);

                                    if (data?.length === 0) {
                                      saveCheckCompanions(values, index);
                                    }
                                  } else if (!item?.leadId && item?.patient?.id) {
                                    const data =
                                      await handleChangeFormSearchDuplicateOnlyLead(
                                        {
                                          phoneNumber,
                                          oldData: values, // luu tạm dữ liệu hiện tại,lưu vào biến search duplicate để có thể set lại sau khi chọn
                                          currentIndex: index,
                                        }
                                      );
                                    //console.log("data", data);
                                    if (data?.length === 0) {
                                      await saveCheckCompanions(values, index);
                                    }
                                  } else {
                                    saveCheckCompanions(values, index);
                                  }
                                }
                              } catch (error) {
                                console.error(error);
                              } finally {
                                setDisabledCheckInIndexes((prev) =>
                                  prev.filter((i) => i !== index)
                                );
                              }
                            }}
                          >
                            <SendIcon />
                            {!isMobile && "CheckIn"}
                          </CommonButton>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                  <DialogCheckIn
                    handleSubmit={async (newValues) => {
                      await saveCheckCompanions(newValues, index);
                    }}
                    index={index}
                  />
                  <DialogHasAppointment
                    handleSubmit={async (newValues) => {
                      await saveCheckCompanions(newValues, index);
                    }}
                    index={index}
                  />
                </Grid>
              ))}
            </>
          )}
        </FieldArray>
      </Grid>
    </>
    );
  }
);

const DialogCheckIn = observer(({ handleSubmit, index }) => {
  const { values } = useFormikContext();
  const { openConfirmCheckIns, setOpenConfirmCheckIns } =
    useStore().patientManagementStore.listCheckInStore;
  return (
    <>
      {!!openConfirmCheckIns &&
        index === openConfirmCheckIns?.companionsIndex && (
          <GlobitsConfirmationDialog
            title="Tiếp tục check in!"
            text={openConfirmCheckIns?.responseDetail}
            onConfirmDialogClose={() => {
              setOpenConfirmCheckIns(null);
            }}
            onYesClick={async () => {
              let newCompanions = values?.companions?.map((el, ind) => {
                if (ind === index) return { ...el, skipCheckValiate: true };
                else return el;
              });
              await handleSubmit({ ...values, companions: newCompanions });
              setOpenConfirmCheckIns(null);
            }}
            cancel="Hủy"
            agree="Tiếp tục"
            open={!!openConfirmCheckIns}
          />
        )}
    </>
  );
});

const DialogHasAppointment = observer(({ handleSubmit, index }) => {
  const { values } = useFormikContext();
  const { openConfirmHasAppointment, setOpenConfirmHasAppointments } =
    useStore().patientManagementStore.listCheckInStore;
  return (
    <>
      {!!openConfirmHasAppointment &&
        index === openConfirmHasAppointment?.companionsIndex && (
          <GlobitsConfirmationDialog
            maxWidth={"xs"}
            title="Tiếp tục check in!"
            text={openConfirmHasAppointment?.responseDetail}
            onConfirmDialogClose={() => {
              setOpenConfirmHasAppointments(null);
            }}
            onYesClick={async () => {
              let newCompanions = values?.companions?.map((el, ind) => {
                if (ind === index)
                  return {
                    ...el,
                    skipCheckValiate: true,
                    appointmentId: openConfirmHasAppointment?.appointmentId,
                  };
                else return el;
              });
              await handleSubmit({ ...values, companions: newCompanions });

              setOpenConfirmHasAppointments(null);
            }}
            cancel="Hủy"
            agree="Cập nhật lịch"
            open={!!openConfirmHasAppointment}
          />
        )}
    </>
  );
});

const CheckDuplicatePhoneButton = observer(({ handleCheckDuplicatePhone }) => {
  return (
    <>
      <>
        <div className="flex align-end">
          <Tooltip title="Kiểm tra trùng số điện thoại">
            <CommonButton
              className="btn-primary"
              onClick={handleCheckDuplicatePhone}
            >
              <IconSearch />
            </CommonButton>
          </Tooltip>
        </div>
      </>
    </>
  );
});


export const CustomerInfoSelectPhone = (data) => {
  return (
    <>
      {!data?.leadId &&
        data?.patient?.id &&
        `Đã chọn KH (${data?.patient?.code} ${data?.patient?.displayName || data?.patient?.fullName
        })`}
      {data?.leadId &&
        `Đã chọn Lead (${data?.patient?.leadCode} ${data?.patient?.displayName})
                                          ${data?.patient?.currentPatientSource
          ? ` - Nguồn: ${data?.patient?.currentPatientSource?.name}`
          : ""
        }
                                           ${data?.patient?.currentTelesale
          ? ` - Telesale: ${data?.patient?.currentTelesale?.staffName}`
          : ""
        }
                                          
                                          `}
    </>
  );
};

const CompanionSharedSourceEffect = observer(() => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    const sharedSource = values?.currentPatientSource?.sharedSource;
    if (sharedSource && Array.isArray(values.companions)) {
      values.companions.forEach((companion, index) => {
        if (!companion.currentPatientSource || companion.currentPatientSource.id !== sharedSource.id) {
           setFieldValue(`companions[${index}].currentPatientSource`, sharedSource);
           setFieldValue(`companions[${index}].currentPatientSourceDetail`, null);
        }
      });
    }
  }, [values?.currentPatientSource, values.companions]);

  return null;
});

export default memo(observer(ListCheckInDependentPerson));
